import React from 'react'
import "../Styles/Settings.css"

function Settings() {
  return (
    <div className="editProfile_container">
        <h2 className="editProfile_title">Settings</h2>
        <div className='tourInfo_card' style={{display:"flex",gap:"20px"}}>
            <button className='settings_btn phone_change_button'>Change Phone Number</button>
            <button className='settings_btn delete_account_button'>Delete Account</button>
        </div>

    </div>
  )
}

export default Settings